interface BulletGridProps {

    items: string[];
}

export function BulletGrid({
    items,
}: BulletGridProps) {
    return (

        <div className="grid gap-4 md:grid-cols-2">

            {items.map((item) => (

                <div
                    key={item}
                    className="flex gap-4 rounded-xl border border-border bg-card p-5"
                >

                    <span
                        className="mt-2 h-2.5 w-2.5 rounded-full bg-primary"
                    />

                    <span className="leading-7">

                        {item}

                    </span>

                </div>

            ))}

        </div>

    );
}